// extracted by mini-css-extract-plugin
export var redoItem = "_k2-1";
export var redoTrigger = "_k2-0";